/*eslint-disable */
let BaseURL = process.env.VUE_APP_API_BASE_URL;
let LBILBaseURL = process.env.VUE_APP_LBIL_API_BASE_URL;
let root = {
// Ann Url
annUrl: {
  "link": BaseURL + "api/ml/ann/"
},
// Knn Url
knnUrl: {
  "link": BaseURL + "api/ml/knn/"
},
// Svm Url
svmUrl: {
  "link": BaseURL + "api/ml/svm/"
},
// Naive Bayes Url
nbUrl: {
  "link": BaseURL + "api/ml/naive-bayes/"
},
// Knn Psm Url
knnPsmUrl: {
  "link": BaseURL + "api/ml/knn-psm/"
},
// Random Forest Psm Url
randomForestUrl: {
  "link": BaseURL + "api/ml/random-forest/"
},
// Decision Tree Url
decisionTreeUrl: {
  "link": BaseURL + "api/ml/decision-tree/"
},
// Login User Url
loginUrl: {
  "link": BaseURL + "api/account/user/email/verify/"
},
// Login User Otp Url
loginOtpUrl: {
  "link": BaseURL + "api/account/user/email/verify/otp/"
},
// Data Well Url
dataWellUrl: {
  "link": BaseURL + "api/tasks/user/tasks/"
},
// Account Details Url
acUserUrl: {
  "link": BaseURL + "api/account/user/web-superuser/"
},
// Data Well Url
dataTaskUrl: {
  "link": BaseURL + "api/tasks/su/"
},
// Organizations List URL
organizationListUrl: {
  "link": BaseURL + "api/account/su/organization/"
},
// Account Org User Create URL
acOrgUserUrl: {
  "link": BaseURL + "api/account/su/user/"
},
//User Task List  URL
userTaskUrl: {
  "link": BaseURL + "api/tasks/su/user/"
},
//Task Read URL
taskReadUrl: {
  "link": BaseURL + "api/tasks/su/"
},
// Organization User To Admin Url
orgUserChangeToAdminUrl:{
  "link": BaseURL + "api/account/su/organization/change-admin/"
},
// Super Admin Organization Url
sAdminsOrgUrl:{
  "link" : BaseURL + "api/account/admin/organization/"
},
// Super Admin User Url
sAdminsOrgUserUrl:{
  "link" : BaseURL + "api/account/admin/user/"
},
// Super Admin User Task Url
sAdminsOrgUserTaskUrl:{
  "link" : BaseURL + "api/tasks/admin/user/"
},
// Input Attributes List Url
inputAttributesListUrl:{
  "link" : BaseURL + "api/tasks/user/input-attributes/"
},
// CHat Room Create Url
chatRoomCreateUrl:{
  "link" : BaseURL + "api/chat_app/room_create/"
},
// User Chat List
userChatListUrl:{
  "link" : BaseURL + "api/chat_app/super_user/chat/list/"
},
// Normal User Chat List
normalUserChatListUrl:{
  "link" : BaseURL + "api/chat_app/user_list/"
},
// Normal Org  List
normalOrgListUrl:{
  "link" : BaseURL + "api/chat_app/organization_list/"
},
// User Chat List
adminChatDetailsUrl:{
  "link" : BaseURL + "api/chat_app/super_user/chat/detail/"
},
// User Chat List
userChatDetailsUrl:{
  "link" : BaseURL + "api/chat_app/web-chat/detail/"
},
// CHat connection request
chatConnectionRequestUrl:{
  "link" : BaseURL + "api/chat_app/chat_connection_request/"
},
// Msg Read Status
msgReadStatusUrl:{
  "link" : BaseURL + "api/chat_app/update_read_status/"
},
//  Status
apporveChatRequestUrl:{
  "link" : BaseURL + "api/chat_app/update_chat_request_status/"
},
// Normal Chat LIst
normalChatListUrl:{
  "link" : BaseURL + "api/chat_app/chat/list/"
},
// Organization Connection Request LIst
orgConnectionReqListUrl:{
  "link" : BaseURL + "api/chat_app/super_user/chat_request/"
},
// User Connection Request LIst
userChatReqListUrl:{
  "link" : BaseURL + "api/chat_app/super_user/chat_list/"
},
// Update Profile Url
updateProfileUrl:{
  "link" : BaseURL + "api/account/user/"
},
// Update Profile Avatar Url
updateProfileAvatarUrl:{
  "link" : BaseURL + "api/account/user/avatar/"
},
// Su Ac Update Url
suAcUpdatesUrl:{
  "link" : BaseURL + "api/account/su/updates/"
},
// Su Ac Update Url
nuAcUpdatesUrl:{
  "link" : BaseURL + "api/account/user/updates/"
},
// Covid List Url
getCovidListUrl:{
  "link" : BaseURL + "api/ml/pandemic-simulator-sir/"
},
// Block User Url
blockUserUrl:{
  "link" : BaseURL + "api/chat_app/block_user/"
},
// UnBlock User Url
unblockUserUrl:{
  "link" : BaseURL + "api/chat_app/unblock_user/"
},
// UnBlock User Url
uploadMsgFileUrl:{
  "link" : BaseURL + "api/chat_app/upload_message_file/"
},
// Request Apporved Url
requestApprovedUrl:{
  "link" : BaseURL + "api/chat_app/connection_request_action/"
},
// PSM WEIGHT CREATE ALGO
knnPsmWeightUrl:{
  "link" : BaseURL + "api/ml/task_2/knn-psm-weighted/"
},
//Brain Tumour CREATE ALGO
brainTumourUrl:{
  "link" : BaseURL + "api/ml/task_4/brain_tumour_assign_cnn/"
},
//USER MOBILE NO CREATED
mobileNoUrl:{
  "link" : BaseURL + "api/account/user/mobile-verify/"
},
//MOBILE NO VERIFY URL
mobileNoVerifyUrl:{
  "link" : BaseURL + "api/account/user/mobile-update/"
},
//ROOM CREATE URL FOR VIDEO
roomCreateUrl:{
  "link" : BaseURL + "api/account/user/room-create/"
},
// CHat Browser Notification
chatBrowserNotificationtUrl:{
  "link" : BaseURL + "api/chat_app/chat_browser_notifications/"
},
// CHat Browser Notification
chatBrowserNotificationtUrl:{
  "link" : BaseURL + "api/chat_app/chat_browser_notifications/"
},
// User Search for new chat
userSearchForChatUrl:{
  "link" : BaseURL + "api/account/user/search/"
},
// User Details Url
userDetailsUrl:{
  "link" : BaseURL + "api/account/user/user/"
},
// Check Login User
userLoginDetailsUrl:{
  "link" : BaseURL + "api/account/user/get-email-mobile/"
},
// Deactivated User Url
deactivatedUsersListsUrl:{
  "link" : BaseURL + "api/account/su/inactive-users/"
},
// Deactivated User Url
memberFiltersTotalCountUrl:{
  "link" : BaseURL + "api/account/su/category-user-count/"
},
// Check Room ID Valid
roomMeetingIdValidUrl:{
  "link" : BaseURL + "api/chat_app/chat-room-data/"
},
// Registration Create Link 
newUserRegisteredUrl:{
  "link" : BaseURL + "api/account/su/sign-up/"
},
// Signuped user list Link 
newSignupedUserListUrl:{
  "link" : BaseURL + "api/account/su/signed-up-list/"
},
// User Agreement Link
userAgreementUrl:{
  "link" : BaseURL + "api/account/user/task-disclaimer/"
},
// Member Filter All User
memberFitersAllUserListsUrl:{
  "link" : BaseURL + "api/account/su/new_all_user/"
},
// All User to Send Email Url
globalAllUserSendMailUrl:{
  "link" : BaseURL + "api/account/su/multiple-user-mail/"
},
// Selected User to Send Email Url
selectedAllUserSendMailUrl:{
  "link" : BaseURL + "api/account/su/selected-user-mail/"
},
// Unsigned Up User to Send Email Url
unSignedUpAllUserSendMailUrl:{
  "link" : BaseURL + "api/account/su/unsigned-user-mail/"
},
// Auth User Agreement Api
authUserAgreementUrl:{
  "link" : BaseURL + "api/account/user/user-agreement-logs/"
},
// Profession Categories List Api
professionCategoriesListUrl:{
  "link" : BaseURL + "api/account/user/get-categories/"
},
emailUpdateOfProfileUrl:{
  "link" : BaseURL + "api/account/user/edit-email-address/"
},
emailVerifiedOfProfileUrl:{
  "link" : BaseURL + "api/account/user/confirm-edit-email-address/"
},
conferenceInfoApiUrl:{
  "link" : BaseURL + "api/account/user/video-conf-user/"
},
authConferenceInfoApiUrl:{
  "link" : BaseURL + "api/account/user/video-conf-user-auth/"
},
// Confrence User Count Api
confrenceUserCountUrl:{
  "link" : BaseURL + "api/chat_app/count-chat-room-data/"
},
// Confrence User Count Api Create
confrenceUserCountCreateUrl:{
  "link" : BaseURL + "api/chat_app/chat-room-data/"
},
// Confrence User Count Api Left
confrenceUserCountLeftUrl:{
  "link" : BaseURL + "api/chat_app/leave-chat-room/"
},
// Member Search Url
memberSearchKeyUrl:{
  "link" : BaseURL + "api/account/user/search/"
},
// Guest User All List
guestAllUsersListUrl:{
  "link" : BaseURL + "api/account/su/guest-list/"
},
// Get Meeting List
getAllMeetingListUrl:{
  "link" : BaseURL + "api/chat_app/super_user/group-video-room/"
},
// Create New Meeting
createNewMeetingListUrl:{
  "link" : BaseURL + "api/chat_app/super_user/group-video-room/"
},
// Update New Meeting
updateMeetingDetailsUrl:{
  "link" : BaseURL + "api/chat_app/super_user/group-video-room/"
},
// New User Verification Url
newUserVerificationUrl:{
  "link" : BaseURL + "api/account/user/signup-mobile-update/"
},
// Webinar All List Url
webinarListUrl:{
  "link" : BaseURL + "api/chat_app/super_user/list-group-video-room/"
},
// Create Webinar All List Url
createWebinarListUrl:{
  "link" : BaseURL + "api/chat_app/super_user/group-video-room/"
},
// Blog Url
blogApiUrl:{
  "link" : BaseURL + "api/account/user/user-blogs/"
},
//Public Blog List Url
publicBlogApiUrl:{
  "link" : BaseURL + "api/account/user/public-user-blogs/"
},
//Public Blog List Url
publicSingleBlogDetailsApiUrl:{
  "link" : BaseURL + "api/account/user/public-blog-detail/"
},
//Suggestion Blog List Url
suggestionBlogApiUrl:{
  "link" : BaseURL + "api/account/user/suggestion-user-blogs/"
},
// User Suppert Help Url
workspaceUserSearchApiUrl:{
  "link" : BaseURL + "api/chat_app/chat-search/"
},
// User Suppert Help Url
userSupportHelpApiUrl:{
  "link" : BaseURL + "api/chat_app/help-chat/detail/"
},
//  Member Filter Main Category Url
memberFiltersMainCatApiUrl:{
  "link" : BaseURL + "api/account/su/member_category/"
},
//  Member Filter Professional Category Url
memberFiltersProCatApiUrl:{
  "link" : BaseURL + "api/account/su/professional_category/"
},
//  Member Filter Professional Sub Category Url
memberFiltersProSubCatApiUrl:{
  "link" : BaseURL + "api/account/su/professional_sub_category/"
},
// Super User Read Blog List
blogListForSuApiUrl:{
  "link" : BaseURL + "api/account/su/blogs/"
},
// Filters List For SignUp Form 
memberFiltersForSignUpApiUrl:{
  "link" : BaseURL + "api/account/user/member-category/"
},
// Filters Index List For SignUp Form 
memberFiltersIndexApiUrl:{
  "link" : BaseURL + "api/account/su/member_category_index/"
},
// Filters Index List For SignUp Form 
notesApiUrl:{
  "link" : BaseURL + "api/account/user/user-notes/"
},
// CHat Group List Api
groupChatListApiUrl:{
  "link" : BaseURL + "api/chat_app/group/chat/list/"
},
// Group Chat Details Api
getGroupChatDetailsApiUrl:{
  "link" : BaseURL + "api/chat_app/web-chat/detail/"
},
leaveGroupRoomApiUrl:{
  "link" : BaseURL + "api/chat_app/leave-group-chat/"
},
updateGroupRoomDetailsApiUrl:{
  "link" : BaseURL + "api/chat_app/group/chat/detail/"
},
getGroupDetailsByIdApiUrl:{
  "link" : BaseURL + "api/chat_app/group-chat-detail/"
},
makeUserToGroupAdminApiUrl:{
  "link" : BaseURL + "api/chat_app/admin-assign-group-chat/"
},
unsbcrbUserApiUrl:{
  "link" : BaseURL + "api/account/user/unsbcrb/"
},
userRemovedFromGroupApiUrl:{
  "link" : BaseURL + "api/chat_app/remove-group-chat/"
},
algoDataApiUrl:{
  "link" : BaseURL + "api/tasks/user/algo-data/"
},
allPubAlgoDApiUrl:{
  "link" : BaseURL + "api/tasks/user/new-all-algo-data/"
},
algoDataForModelTrainedApiUrl:{
  "link" : BaseURL + "api/tasks/user/full-all-algo-data/"
},
removedAdminFromGroupApiUrl:{
  "link" : BaseURL + "api/chat_app/admin-unassign-group-chat/"
},
briefCaseApiUrl:{
  "link" : BaseURL + "api/account/user/briefcase-folder/"
},
unsubscribedUserListApiUrl:{
  "link" : BaseURL + "api/account/su/unsubscribed-users-list/"
},
notesSharedApiUrl:{
  "link" : BaseURL + "api/account/user/shared-user-notes/"
},
allUserCountApiUrl:{
  "link" : BaseURL + "api/account/su/counts-user/"
},
allUserAlgoDataApiUrl:{
  "link" : BaseURL + "api/tasks/user/all-algo-data/"
},
isConditionalListOfAllUsersApiUrl:{
  "link" : BaseURL + "api/account/su/notes_all_user/"
},
createModelsForAIApiUrl:{
  "link" : BaseURL + "api/tasks/user/trained-models/"
},
modelsForAITaskApiUrl:{
  "link" : BaseURL + "api/tasks/user/model-training/"
},
viewModelInfoByIdApiUrl:{
  "link" : BaseURL + "api/tasks/user/view-trained-model/"
},
countForAITaskApiUrl:{
  "link" : BaseURL + "api/tasks/user/ai-dashboard-counts/"
},
mostUsedTrainModelForAiDashApiUrl:{
  "link" : BaseURL + "api/tasks/user/most-used-trained-models/"
},
modelsUsingApiUrl:{
  "link" : BaseURL + "api/tasks/user/use-trained-models/"
},
trainedModelsAttrApiUrl:{
  "link" : BaseURL + "api/tasks/user/paginated-trained-models-attributes/"
},
trainedModelsAttrForUseApiUrl:{
  "link" : BaseURL + "api/tasks/user/paginated-use-trained-models-attributes/"
},
searchingTrainedModelsApiUrl:{
  "link" : BaseURL + "api/tasks/user/search-trained-models/"
},
historiesOfTrainedModelsApiUrl:{
  "link" : BaseURL + "api/tasks/user/history-trained-models/"
},
getProfilePhotoOfCurrentApiUrl:{
  "link" : BaseURL + "api/account/user/get-user-image/"
},
sharedBriefcaseApiUrl:{
  "link" : BaseURL + "api/account/user/shared-briefcase-folder/"
},
sharedBriefcaseForUserSpcApiUrl:{
  "link" : BaseURL + "api/account/user/get-shared-briefcase-users/"
},
sharedBriefcaseRemovedApiUrl:{
  "link" : BaseURL + "api/account/user/delete-shared-briefcase/"
},
diseaseCatApiUrl:{
  "link" : BaseURL + "api/account/user/get-disease/"
},
aboutOfUserPrflApiUrl:{
  "link" : BaseURL + "api/account/user/web-about-us/"
},
aboutOfMemberUserPrflApiUrl:{
  "link" : BaseURL + "api/account/su/about-us/"
},
deleteMsgApiUrl:{
  "link" : BaseURL + "api/chat_app/delete-message/"
},
allLeftChatListDetailsUrl:{
  "link" : BaseURL + "api/chat_app/combined-chat-list/"
},
chatRoomPinnedApiUrl:{
  "link" : BaseURL + "api/chat_app/pin-chat/"
},
chatRoomPinnedListApiUrl:{
  "link" : BaseURL + "api/chat_app/pinned-chat/list/"
},
notesSharedinGroupApiUrl:{
  "link" : BaseURL + "api/account/user/grp-shared-user-notes/"
},
notesSharedGroupListApiUrl:{
  "link" : BaseURL + "api/chat_app/notes-grp/list/"
},
notesReadStatusApiUrl:{
  "link" : BaseURL + "api/account/user/read-status-grp-shared-user-notes/"
},
algoDataSharedApiUrl:{
  "link" : BaseURL + "api/tasks/user/shared-algo-data/"
},
schedulerApiUrl:{
  "link" : BaseURL + "api/account/user/calender_reminder/"
},
newSchedulerApiUrl:{
  "link" : BaseURL + "api/account/user/update_calender_reminder/"
},
sharedModulsApiUrl:{
  "link" : BaseURL + "api/tasks/user/shared-trained-model/"
},
newEmployeeUserApiUrl:{
  "link" : BaseURL + "api/account/su/employee-sign-up/"
},
employeeListUrl:{
  "link" : BaseURL + "api/account/su/employee_all_user/"
},
updateEmployeeInfoUrl:{
  "link" : BaseURL + "api/account/user/employee-update/"
},
employeeLeaveUrl:{
  "link" : BaseURL + "api/account/user/leave-application/"
},
adminEmployeeLeaveUrl:{
  "link" : BaseURL + "api/account/user/user-leave-application/"
},
forwardMsgUserApiLink:{
  "link" : BaseURL + "api/chat_app/forward-msg/"
},
forwardMultiMsgUserApiLink:{
  "link" : BaseURL + "api/chat_app/new-forward-msg/"
},
chatWithUserSearchApiUrl:{
  "link" : BaseURL + "api/chat_app/chat-list-search/"
},
emplooyeTaskApiUrl:{
  "link" : BaseURL + "api/account/user/employee-task/"
},
interviewLogApiUrl:{
  "link" : BaseURL + "api/account/user/interview-log/"
  // "link" : BaseURL + "api/account/su/interviews/"
},
activityLogOfUserApiUrl:{
  "link" : BaseURL + "api/tasks/user/activity-log/"
},
briefcaseStorageInfoOfTeamHeadApiUrl:{
  "link" : BaseURL + "api/account/user/size-team-count/"
},
storageBreakDownOfTeamHeadApiUrl:{
  "link" : BaseURL + "api/account/user/child-list/"
},
filesInfoOfStorageApiUrl:{
  "link" : BaseURL + "api/account/user/only-files-briefcase/"
},
briefcaseActivityLogApiUrl:{
  "link" : BaseURL + "api/account/user/log-briefcase-activity/"
},
voteBlogApiUrl:{
  "link" : BaseURL + "api/account/user/vote-blog/"
},
voteBlogInfoApiUrl:{
  "link" : BaseURL + "api/account/user/count-votes-blog/"
},
zoomMeetingCreateApiUrl:{
  "link" : BaseURL + "api/chat_app/zoom-meeting-create/"
},
vistaSignupUsersListApiUrl:{
  "link" : BaseURL + "api/account/user/zoom-meeting-user/"
},
memberConnectedUsersApiUrl:{
  "link" : BaseURL + "api/account/user/connection-list/"
},
connectedMemberSearchKeyUrl:{
  "link" : BaseURL + "api/account/user/connection-search-list/"
},
getPublicWebinarApiUrl:{
  "link" : BaseURL + "api/chat_app/public-webinar/"
},
connectedMemberCountApiUrl:{
  "link" : BaseURL + "api/account/su/connected-cat-user-count/"
},
removedAproveLeaveApiUrl:{
  "link" : BaseURL + "api/account/user/leave-application/"
},
getUserNameListFromGroupApiUrl:{
  "link" : BaseURL + "api/chat_app/group/user-detail/"
},
userOnlineTimeCountApiUrl:{
  "link" : BaseURL + "api/account/user/online-time-count/"
},
allUserOnlineTimeCountApiUrl:{
  "link" : BaseURL + "api/account/user/online-time-count/"
},
staffUserMailForTestingApiUrl:{
  "link" : BaseURL + "api/account/su/staff-user-mail/"
},
rListUsersApiUrl:{
  "link" : BaseURL + "api/account/su/rlist/"
},
roomCreateIdforGlobalSocketApi:{
  "link" : BaseURL + "api/account/user/generate-user-common-room/"
},
// Doctors List Api Url
doctorConsultRequestListApiUrl: {
    "link": BaseURL + "api/account/su/doctor-schedule/"
},
lbilNgoListApiUrl:{
  "link": LBILBaseURL + "api/account/user/lymphomap-ngo-form/"
},
lbilNgoInfoUpdateApiUrl:{
  "link": LBILBaseURL + "api/account/user/lbil-new-update-ngo/"
},
lbilSGListApiUrl:{
  "link": LBILBaseURL + "api/account/user/lymphomap-support-group-form/"
},
lbilSGInfoUpdateApiUrl:{
  "link": LBILBaseURL + "api/account/user/lbil-new-update-ngo/"
},
lbilUsersListApiUrl:{
  "link": BaseURL + "api/account/user/lbil-member-users/"
},
createPlanApiUrl:{
  "link": BaseURL + "api/account/payments/create-plan/"
},
createProductApiUrl:{
  "link": BaseURL + "api/account/payments/create-product/"
},
getPlanListApiUrl:{
  "link": BaseURL + "api/account/payments/plan-list/"
},
getAllSubscriptionProductApiUrl:{
  "link": BaseURL + "api/account/payments/product-list/"
},
deactivatePlanApiUrl:{
  "link": BaseURL + "api/account/payments/deactivate-plan/"
},
activatePlanApiUrl:{
  "link": BaseURL + "api/account/payments/activate-plan/"
},
allPlanClearApiUrl:{
  "link": BaseURL + "api/account/payments/delete-plans-from-db/"
},
allProductClearApiUrl:{
  "link": BaseURL + "api/account/payments/delete-products-from-db/"
},
presentationFileUploadApiUrl:{
  "link": BaseURL + "api/account/user/upload-files-to-s3-bucket/"
},
activityTrackerApiUrl:{
  "link": BaseURL + "api/account/user/activity-tracker/"
},
meetingReminderApiUrl:{
  "link": BaseURL + "api/chat_app/super_user/send-reminders-group-video-room/"
},
todoListApiUrl:{
  "link" : BaseURL + "api/account/user/user-todo-list/"
},
allToDoRemoveApiUrl:{
  "link": BaseURL + "api/account/user/delete-all-todo-list/"
},
orgBasedAlgoDataApiUrl:{
  "link": BaseURL + "api/tasks/user/organization-based-algo-data/"
},
orgBasedPublicAlgoDataApiUrl:{
  "link": BaseURL + "api/tasks/user/organization-based-public-algo-data/"
},
orgBasedPrivateAlgoDataApiUrl:{
  "link": BaseURL + "api/tasks/user/organization-based-private-algo-data/"
},
toDoFiltersApiUrl:{
  "link": BaseURL + "api/account/user/filter-user-todo-list/"
},
orgBasedDataListApiUrl:{
  "link": BaseURL + "api/tasks/user/organization-based-filtered-algo-data/"
},
searchAlgoDataApiUrl:{
  "link": BaseURL + "api/tasks/user/search-algo-data/"
},
selfUserActivityTrackerApiUrl:{
  "link" : BaseURL + "api/account/user/self-activity-tracker/"
},
shareTodoApiUrl:{
  "link": BaseURL + "api/account/user/shared-user-todo/"
},
twoFactorOtpVerifyApiUrl:{
  "link" : BaseURL + "api/account/user/mfa/verify/otp/"
},
twoFactorOtpSendApiUrl:{
  "link" : BaseURL + "api/account/user/mfa/verify/"
},
managerLeaveFilterApiUrl:{
  "link" : BaseURL + "api/account/user/manager-leave-application/"
},
stafListForManagerApiUrl:{
  "link" : BaseURL + "api/account/user/manager-staff-view/"
},
adminAnnouncementApiUrl:{
  "link" : BaseURL + "api/account/user/admin-announcement/"
},
getPresentationListApiUrl:{
  "link" : BaseURL + "api/account/user/get-all-presentation/"
},
presentationApiUrl:{
  "link" : BaseURL + "api/account/user/presentation/"
},
userLogoutApiUrl:{
  "link" : BaseURL + "api/account/user/logout/"
},
deletePresentationApiUrl:{
  "link" : BaseURL + "api/account/user/delete-presentation/"
},
getAllDemoRequestListApiUrl:{
  "link" : BaseURL + "api/account/user/request-demo-superuser/"
},
updateDemoReqInfoApiUrl:{
  "link" : BaseURL + "api/account/user/request-demo-superuser/"
},
loginUserApiUrl:{
  "link": BaseURL + "api/account/user/web-staff-login/"
},
removeDemoReqApiUrl:{
  "link": BaseURL + "api/account/user/delete-request-demo/"
},
uploadUsrCVApiUrl:{
  "link": BaseURL + "api/account/user/web-update-cv/"
},
getCVbyUserIdApiUrl:{
  "link": BaseURL + "api/account/user/web-show-cv/"
},
deleteCvFromSelfId:{
  "link": BaseURL + "api/account/user/web-delete-cv/"
},
timeSlotsForDemoApiUrl:{
  "link": BaseURL + "api/account/user/time-slots/"
},
userReqForDemoApiUrl:{
  "link": BaseURL + "api/account/user/user-request-demo/"
},
messageSearchApiUrl:{
  "link": BaseURL + "api/chat_app/message-search/"
},
uploadFolderInBriefcaseApiUrl:{
  "link": BaseURL + "api/account/user/briefcase-folder-upload/"
},
uploadFilesInBriefcaseApiUrl:{
  "link": BaseURL + "api/account/user/briefcase-files-upload/"
},
constantAIModelApiUrl:{
  "link": BaseURL + "api/tasks/user/use-random-forest/"
},
modelPerformanceParameterListApiUrl:{
  "link": BaseURL + "api/tasks/user/model-performance-parameters/"
},
// Paper Pile API URLS
pdfPaperPileApiUrl:{
  "link" : BaseURL + "api/account/user/pdf-paper/"
},
searchPaperPileApiUrl:{
  "link" : BaseURL + "api/account/user/pdf-paper-search/"
},
researchGroupForAwerackApiUrl:{
  "link" : BaseURL + "api/account/user/research-group/"
},
bucketForAwerackApiUrl:{
  "link" : BaseURL + "api/account/user/bucket/"
},
commentOnResearchGroupApiUrl:{
  "link" : BaseURL + "api/account/user/research-group-comment/"
},
notesOfPdfApiUrl:{
  "link" : BaseURL + "api/account/user/notes-pdf-paper/"
},
updateNotesOfPdfApiUrl:{
  "link" : BaseURL + "api/account/user/note-pdf-paper-detail/"
},
favouritePaperListApiUrl:{
  "link" : BaseURL + "api/account/user/favourite-pdf-pap/"
},
awerackPDFDataRefreshApiUrl:{
  "link" : BaseURL + "api/account/user/reload-pdf-pap/"
},
trashPaperListApiUrl:{
  "link" : BaseURL + "api/account/user/trash-pdf-pap/"
},
awerackPaperSharedApiUrl:{
  "link" : BaseURL + "api/account/user/shared-pdf-pape/"
},
trashPaperRestoreApiUrl:{
  "link" : BaseURL + "api/account/user/restore-trash-data/"
},
trashFolderListApiUrl:{
  "link" : BaseURL + "api/account/user/trash-bucket/"
},
sharedPaperListApiUrl:{
  "link" : BaseURL + "api/account/user/shared-pdf-pape/"
},
allTrashClearApiUrl:{
  "link" : BaseURL + "api/account/user/clear-all-trash/"
},
uploadPDFFromQueryApiUrl:{
  "link": BaseURL + "api/tasks/user/search-research-paper/"
},
savedQuerySearchPaperApiUrl:{
  "link": BaseURL + "api/tasks/user/save-research-paper/"
},
uploadPaperFromDoiApiUrl:{
  "link": BaseURL + "api/tasks/user/view-doi-paper/"
},
savedDoiSearchPaperApiUrl:{
  "link": BaseURL + "api/tasks/user/save-doi-paper/"
},
citationGetApiUrl:{
  "link": BaseURL + "api/tasks/user/create-citation/"
},
saveAnnotationApiUrl:{
  "link": BaseURL + "api/tasks/user/save-annotation/"
},
createCitationForAllApiUrl:{
  "link": BaseURL + "api/tasks/user/create-citation-for-all-file/"
},
checkMetadataOfPaperApiUrl:{
  "link": BaseURL + "api/tasks/user/check-metadata-for-papers/"
},
// Paper Pile API URLS
sentEmailSmsListApiUrl:{
"link": BaseURL + "api/account/su/email-sms-history/"
},
recommendedParametersApiUrl:{
  "link": BaseURL + "api/tasks/user/last-used-model-performance-parameters/"
},
sampleFileForModelApiUrl:{
  "link": BaseURL + "api/tasks/user/blank-csv-download/"
},
uploadBatchFileForModelApiUrl:{
  "link": BaseURL + "api/tasks/user/upload-batch-csv/"
},
// Notification API URLS
globalNotificationApiUrl:{
  "link" : BaseURL + "api/account/user/add-notification/"
},
globalNotificationListApiUrl:{
  "link" : BaseURL + "api/account/user/global-notification/"
},
allNotificationReadListApiUrl:{
  "link" : BaseURL + "api/account/user/read-all-global-notification/"
},
inViewerListApiUrl:{
  "link" : BaseURL + "api/account/su/interviews/"
},
inViewerCandidatesApiUrl:{
  "link" : BaseURL + "api/account/su/candidates/"
},
eventApiUrl:{
  "link" : BaseURL + "api/account/user/events/"
},
eventGalleriesApiUrl:{
  "link" : BaseURL + "api/account/user/event-galleries/"
},
eventInfoByIDApiUrl:{
  "link" : BaseURL + "api/account/user/eventById/"
},
qBankApiUrl:{
  "link" : BaseURL + "api/account/su/questionbanks/"
},
qBankListApiUrl:{
  "link" : BaseURL + "api/account/su/questionbank/"
},
questionApiUrl:{
  "link" : BaseURL + "api/account/su/questions/"
},
ansOptionApiUrl:{
  "link" : BaseURL + "api/account/su/options/"
},
questionBankCandidatesApiUrl:{
  "link" : BaseURL + "api/account/su/questionbankcandidates/"
},
getQueWithOptionInfoApiUrl:{
  "link" : BaseURL + "api/account/su/question/"
},
cadidateInfoWithQBankApiUrl:{
  "link" : BaseURL + "api/account/su/candidate/"
},
removeCandidateFromQbankApiUrl:{
  "link" : BaseURL + "api/account/su/questionbankcandidate/delete/"
},
candidateContestHistoryApiUrl:{
  "link" : BaseURL + "api/account/su/candidate-stats/"
},
qbanksLinkToCandidateListForAdminApiUrl:{
  "link" : BaseURL + "api/account/su/questionbankcandidate/admin-get/"
},
notesSearchApiUrl:{
  "link" : BaseURL + "api/account/user/user-notes-search/"
},
getAllUserChatListMBLUrl:{
  "link" : BaseURL + "api/chat_app/full-chat/list/"
},
groupDeleteApiUrl:{
  "link" : BaseURL + "api/chat_app/delete-group/"
},
deleteDataListApiUrl:{
  "link": BaseURL + "api/tasks/user/get-all-deleted-data/"
},
dataDeleteApiUrl:{
  "link": BaseURL + "api/tasks/user/delete-data/"
},
dataRestoreApiUrl:{
  "link": BaseURL + "api/tasks/user/restore-data/"
},
shareDatasetApiUrl:{
  "link" : BaseURL + "api/tasks/user/shared-data/"
},
incomingSharedDatasetApiUrl:{
  "link" : BaseURL + "api/tasks/user/shared-data-tome/"
},
outgoingSharedDatasetApiUrl:{
  "link" : BaseURL + "api/tasks/user/shared-data-byme/"
},
botTicketApiUrl:{
  "link" : BaseURL + "api/chat_app/tickets/staff/tickets/"
},
tukivitaFeedbacksApiUrl:{
  "link" : BaseURL + "api/chat_app/chatbot/list/sessions/with-ratings/ "
},
demoFeedbackRequestApiUrl:{
  "link" : BaseURL + "api/account/user/send-demo-feedback-request/"  
},
getAllDemoFeedbackListApiUrl:{
  "link" : BaseURL + "api/account/user/list-demo-feedbacks/"
},
getAllFAQFeedbackListApiUrl:{
  "link" : BaseURL + "api/account/faq/list/"
},
requestForDemoApiUrl:{
  "link": BaseURL + "api/account/user/request-demo/"
},
timeSlotsConvertedApiUrl:{
  "link": BaseURL + "api/account/user/time-slots-converted/"
},
vistaMediaListLink: {
"link": BaseURL + "api/account/user/youtube-media/"
},
vistaUnstyledMediaListLink: {
"link": BaseURL + "api/account/user/auth-youtube-med/"
},
commentOnVideoApiUrl:{
  "link" : BaseURL + "api/account/user/yv-comment/"
},
getListVistaPrivateOfVideoApiUrl:{
  "link" : BaseURL + "api/account/user/list-auth-youtube-med/"
},
getListVistaPublicOfVideoApiUrl:{
  "link" : BaseURL + "api/account/user/list-youtube-media/"
},
privateVideosListApiUrl:{
  "link" : BaseURL + "api/account/user/private-videos/"
},
eventListApiUrl:{
  "link": BaseURL + "api/account/user/eventsList/"
},
eventInfoApiUrl:{
  "link": BaseURL + "api/account/user/eventById/"
},

fetchPinnedChatRoomsApiUrl:{
  "link" : BaseURL + "api/chat_app/pinned-chats/"
},
fetchNormalChatRoomsApiUrl:{
  "link" : BaseURL + "api/chat_app/chat-list/"
},
}
export default root;